import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Button, Input, Select } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import Switchbox from '../../../../components/user/from/Switchbox'
import ViewDraftMeeting from '../../../../components/user/from/MeetingManagement/ViewDraftMeeting'
import ViewWaitApproveMeeting from '../../../../components/user/from/MeetingManagement/ViewWaitApproveMeeting'
import SentNoteApproveMeeting from '../../../../components/user/from/MeetingManagement/SentNoteApproveMeeting'
import { UrlMeeting } from '../../../../utils/auth'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";

const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;
const { Text, Title } = Typography

class WaitMeeting extends React.Component {

    state = {
        dataMeeting: [],
        noteForMeeting: [],
        textSearchWait: "",
        typeSearchWait: "",
        textSentNote: "",
        typeSentNote: "",
    }
    componentDidMount = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingpendingapproval`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingDate: "",
                MeetingName: "",
                OptionSearch: ""
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                // console.log("listmeetingpendingapproval", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingrecordafter`,
            {
                UserID: sessionStorage.getItem('username'),
            })
            .then(response => {
                const data = response.data.status.message.data
                // console.log("listmeetingrecordafter", data);
                this.setState({ noteForMeeting: data ? data : [] })
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeSearchWaitApprove = (value) => {
        // console.log("value", value);
        this.setState({
            textSearchWait: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingpendingapproval`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: value,
                OptionSearch: this.state.typeSearchWait,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                // console.log("dataMeeting", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeTypeWaitApprove = (value) => {
        // console.log("value", value);
        this.setState({
            typeSearchWait: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingpendingapproval`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: this.state.textSearchWait,
                OptionSearch: value,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                // console.log("dataMeeting", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeSearchSentNote = (value) => {
        // console.log("value", value);
        this.setState({
            textSentNote: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingrecordafter`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: value,
                OptionSearch: this.state.typeSentNote,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ noteForMeeting: data ? data : [] })
                // console.log("noteForMeeting", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeTypeSentNote = (value) => {
        // console.log("value", value);
        this.setState({
            typeSentNote: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingrecordafter`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: this.state.textSentNote,
                OptionSearch: value,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ noteForMeeting: data ? data : [] })
                // console.log("noteForMeeting", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }

    render() {
        const { match } = this.props
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div className="card-container meeting-management" id="create-meeting">
                    <div className="p-5 card-bg-white">
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="รออนุมัติ" key="1">
                                <div>
                                    <Row gutter={16} className={'py-4 mr-0 ml-0'}>
                                        <Col xs={24} lg={12}>
                                            <Search
                                                placeholder="ค้นหา"
                                                onSearch={value => this.onChangeSearchWaitApprove(value)}
                                                style={{ width: '100%' }}
                                            />
                                        </Col>
                                        <Col xs={24} md={12} lg={7} >
                                            <Select
                                                showSearch
                                                defaultValue=""
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                onChange={this.onChangeTypeWaitApprove}
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value="" >ทั้งหมด</Option>
                                                <Option value="WAITING">รออนุมัติ</Option>
                                                <Option value="APPROVE">อนุมัติ</Option>
                                                <Option value="REJECT">ไม่อนุมัติ</Option>
                                                <Option value="APPROVEAFTEREDIT">ขอแก้ไขและอนุมัติ</Option>
                                            </Select>
                                        </Col>
                                        {/* <Col xs={24} md={12} lg={5} >
                                            <Button className={'button-meeting-search mt-3 mt-lg-0'}>
                                                ค้นหา</Button>
                                        </Col> */}
                                    </Row>
                                    <div style={{ height: 650, width: '100%', overflow: "auto" }}>
                                        <ViewWaitApproveMeeting dataMeeting={this.state.dataMeeting}></ViewWaitApproveMeeting>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tab="ส่งบันทึกหลังการประชุม" key="2">
                                <div>
                                    <Row gutter={16} className={'py-4 mr-0 ml-0'}>
                                        <Col xs={24} lg={12}>
                                            <Search
                                                placeholder="ค้นหา"
                                                onSearch={value => this.onChangeSearchSentNote(value)}
                                                style={{ width: '100%' }}
                                            />
                                        </Col>
                                        <Col xs={24} md={12} lg={7} >
                                            <Select
                                                showSearch
                                                defaultValue=""
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                onChange={this.onChangeTypeSentNote}
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value="" >ทั้งหมด</Option>
                                                <Option value="WAITING">รอส่ง</Option>
                                                <Option value="SENT">ส่งแล้ว</Option>
                                            </Select>
                                        </Col>
                                        {/* <Col xs={24} md={12} lg={5} >
                                            <Button className={'button-meeting-search mt-3 mt-lg-0'}>
                                                ค้นหา</Button>
                                        </Col> */}
                                    </Row>
                                    <div style={{ height: 650, width: '100%', overflow: "auto" }}>
                                        <SentNoteApproveMeeting dataMeeting={this.state.noteForMeeting}></SentNoteApproveMeeting>
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </Container >
        )
    }
}

WaitMeeting.propTypes = {
    //
}

export default withApollo(WaitMeeting)